import React from 'react'

import { Box, Button, Icon, IconType, Text } from '@vividseats/vivid-ui-kit'
import classNames from 'classnames'

import { FilterFields } from '@/components/pages/production/components/context/types'

import styles from './styles.module.scss'

export enum FilterVariant {
    compact = 'compact',
    default = 'default',
}

type Props = {
    className?: string
    onClick: React.MouseEventHandler<HTMLButtonElement>
    active?: boolean
    iconType?: IconType
    dataTestId?: string
    variant?: FilterVariant
    handleReset?: React.MouseEventHandler<Element>
    modifiedFilterList?: FilterFields[]
}

const FilterButton: React.FC<Props> = ({
    children,
    className,
    onClick,
    active,
    iconType,
    dataTestId = 'filter-button',
    variant = FilterVariant.default,
    handleReset,
    modifiedFilterList = [],
}) => {
    const iconSize = variant === FilterVariant.default ? 'sm' : 'xxs'
    const mergedClassName = classNames(styles[variant], styles.filterButton, className, { [styles.active]: active })
    const hasChanged = modifiedFilterList.length > 0

    const openButton = (
        <Button
            className={
                handleReset
                    ? styles.autoHeight
                    : classNames(mergedClassName, styles.xsPadding, hasChanged && styles.changedFilterButton)
            }
            onClick={onClick}
            importance={handleReset ? 'text' : 'tertiary'}
            data-testid={dataTestId}
            aria-label="filter"
        >
            {iconType && (
                <Icon className={classNames(hasChanged && styles.changedFilterIcon)} size={iconSize} type={iconType} />
            )}
            {!!modifiedFilterList.length && (
                <Text size="xs" className={styles.filterNumText}>
                    {modifiedFilterList.length}
                </Text>
            )}
            {children && (
                <Text
                    as="span"
                    size="md"
                    altFont
                    weight="semi-bold"
                    className={classNames(styles.label, { [styles.active]: active })}
                >
                    {children}
                </Text>
            )}
        </Button>
    )

    return handleReset ? (
        <Box
            className={mergedClassName}
            display="flex"
            flexDirection="row"
            align="center"
            paddingLeft={3}
            paddingRight={3}
        >
            {openButton}
            {active && (
                <button onClick={handleReset} className={styles.closeButton} data-testid={`${dataTestId}-reset`}>
                    <Icon type="close" size="xxs" />
                </button>
            )}
        </Box>
    ) : (
        openButton
    )
}

export default FilterButton
